import { lazy } from 'react';
import Loadable from 'components/Loadable';

const AttendanceDashboard = Loadable(lazy(() => import('./components/attendance-dashboard/AttendanceDashboard')));
const AttendanceList = Loadable(lazy(() => import('./components/attendance-list/AttendanceList')));
const WorkRecords = Loadable(lazy(() => import('./components/work-records/WorkRecords')));
const EmployeeAttendance = Loadable(lazy(() => import('./components/employee-attendance/EmployeeAttendance')));
const AttendanceRegularization = Loadable(lazy(() => import('./components/attendance-regularization/AttendanceRegularization')));
const MissingPunchRequest = Loadable(lazy(() => import('./components/missing-punch-request/MissingPunchRequest')));
const WorkFromHome = Loadable(lazy(() => import('./components/work-from-home/WorkFromHome')));
const BulkAttendanceUpload = Loadable(lazy(() => import('./components/bulk-attendance-upload/BulkAttendanceUpload')));
const ShiftManagement = Loadable(lazy(() => import('./components/shift-management/ShiftManagement')));
const AttendancePolicy = Loadable(lazy(() => import('./components/attendance-policy/AttendancePolicy')));
const WeeklyOffManagement = Loadable(lazy(() => import('./components/weekly-off-management/WeeklyOffManagement')));
const OvertimeManagement = Loadable(lazy(() => import('./components/overtime-management/OvertimeManagement')));
const AttendanceApproval = Loadable(lazy(() => import('./components/attendance-approval/AttendanceApproval')));
const AttendanceReports = Loadable(lazy(() => import('./components/attendance-reports/AttendanceReports')));
const AttendanceSettings = Loadable(lazy(() => import('./components/attendance-settings/AttendanceSettings')));

export const attendanceRoutes = {
  path: 'attendance',
  children: [
    { index: true, element: <AttendanceDashboard /> },
    { path: 'dashboard', element: <AttendanceDashboard /> },
    { path: 'list', element: <AttendanceList /> },
    { path: 'work-records', element: <WorkRecords /> },
    { path: 'daily', element: <AttendanceList /> },
    { path: 'monthly', element: <AttendanceList /> },
    { path: 'my-attendance', element: <EmployeeAttendance /> },
    { path: 'regularization', element: <AttendanceRegularization /> },
    // { path: 'missing-punch', element: <MissingPunchRequest /> },
    { path: 'work-from-home', element: <WorkFromHome /> },
    { path: 'bulk-upload', element: <BulkAttendanceUpload /> },
    { path: 'shift-management', element: <ShiftManagement /> },
    { path: 'policy', element: <AttendancePolicy /> },
    { path: 'weekly-off', element: <WeeklyOffManagement /> },
    { path: 'overtime', element: <OvertimeManagement /> },
    { path: 'approval', element: <AttendanceApproval /> },
    { path: 'reports', element: <AttendanceReports /> },
    { path: 'settings', element: <AttendanceSettings /> }
  ]
};

export default attendanceRoutes;
